import ".././styles/Memberships.css";
import adminlogo from ".././assets/svgs/admin.svg";
import maintenencelogo from ".././assets/svgs/maintenance.svg";
import organizinglogo from ".././assets/svgs/calendar-19-svgrepo-com.svg";
import forumlogo from ".././assets/svgs/forums.svg";
import programslogo from ".././assets/svgs/programs.svg";
import campaignlogo from ".././assets/svgs/announce-svgrepo-com.svg";

function Memberships() {
    return (
        <>
            <div className="container">
                <div className="membership-banner-container" id="banner">
                    <div className="membership-banner">
                        <h1>Memberships</h1>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="sub-container">
                    <div className="membership-section" id="membership-info">
                        <h2 className="section-title">Why Should You Become a PCCM Member?</h2>
                        <ul>
                            <li>
                                <p>Membership is OPEN to individuals of Filipino descent and have permanent residency in Manitoba.</p>
                            </li>
                            <li>
                                <p>To show that you stand behind the mission, objectives, and core values of PCCM.</p>
                            </li>
                            <li>
                                <p>To give you a voice in PCCM’s governance and as a member, you have a right to attend Annual Membership
                                Meetings, right to vote or be eligible to apply, nominated, and run for office as Member of the Governing.
                                Board</p>
                            </li>
                            <li>
                                <p>To have the privilege of discounted use of the Boardroom or Multi-Purpose Room, and discounted cost of
                                tickets to community events that are sponsored by PCCM, and discounts from participating local businesses.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="container" id="membership-categories-section">
                <div className="sub-container memberships">
                    <h2>Types of Members</h2><br />
                    <p>Every PCCM members has volunteered to focused on one of these following responsibilities...</p>
                    <div className="membership-categories">
                        <div className="membership-category">
                            <img className="category-icon"src={adminlogo}></img>
                            <h3>Administrative Support Services</h3>
                        </div>
                        <div className="membership-category">
                            <img className="category-icon"src={campaignlogo}></img>
                            <h3>Membership Campaign</h3>
                        </div>
                        <div className="membership-category">
                            <img className="category-icon"src={maintenencelogo}></img>
                            <h3>Building Upkeep and Maintenance</h3>
                        </div>
                        <div className="membership-category">
                            <img className="category-icon"src={organizinglogo}></img>
                            <h3>Organizing Social and Fundraising Events</h3>
                        </div>
                        <div className="membership-category">
                            <img className="category-icon"src={programslogo}></img>
                            <h3>Programs and Services Development</h3>
                        </div>
                        <div className="membership-category">
                            <img className="category-icon"src={forumlogo}></img>
                            <h3>Organizing Forums and Information Sessions</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="membership-section sub-container" id="membership-req">
                        <h2 className="section-title">Membership Requirements</h2>
                        <p>To register as a PCCM member, you must meet the following criteria:</p><br></br>
                        <ul>
                            <li><p>Be at least 18 years old.</p></li>
                            <li><p>Have ancestral origin from the Philippines.</p></li>
                            <li><p>Be a Canadian Citizen or Permanent Resident in Canada.</p></li>
                            <li><p>Be a resident of Manitoba.</p></li>
                            <li><p>Pay an annual membership fee of $15.00, unless you are 65 years old or over; membership is free for seniors (per Article 3.2 (IV) of the PCCM Constitution and By-Laws).</p></li>
                            <li><p>Have not been suspended, expelled, or resigned as a PCCM member (per Article 3.5 (e) of the PCCM Constitution and By-Laws).</p></li>
                            <li><p>One (1) valid photo ID for validation.</p></li>
                        </ul>
                    </div>
            </div>
            <div className="container">
                <div className="sub-container" id="membership-form">
                    <iframe id="membership-fields"src="https://forms.fillout.com/t/3CuSidyTUdus"  width="100%" height="800" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                </div>
            </div>
        </>
    );
}

export default Memberships;